$("#purchase").click((e) => {
  const cartFill = $(".cart-fill");
  cartFill.animate(
    {
      opacity: "1",
    },
    300
  );
  cartFill.first().addClass("animate-ping");
  setTimeout(function () {
    cartFill.first().removeClass("animate-ping");
  }, 2000);
  $(".custom-sidebar-inner").addClass("custom-sidebar-open");
  custom_update();
});

$("#chat-now").click((e) => {
  e.preventDefault();
  if (window.tidioChatApi) {
    window.tidioChatApi.open();
  }
});
